import Axios from "axios";
import { Dispatch } from "redux";
import { baseURL } from "../axios";
import {
  CONFIRMED_BOOKING,
  RESET_INTERCITY,
  SET_BOOKING_RESET_TRACKING,
  SET_BOOKING_TRACKING,
  SET_INTRACITY,
  SET_INTRACITY_PACKAGES,
  SET_INTRACITY_PICKUP_DROP_LOCATION,
} from "../constants/customerBooking";
import { RootState } from "../store";
import showMessage, { failed, showHttpError, success } from "../utils/message";

const url = baseURL;

const secondsToHms = (d: any) => {
  d = Number(d);
  var h = Math.floor(d / 3600);
  var m = Math.floor((d % 3600) / 60);
  // var s = Math.floor(d % 3600 % 60);

  var hDisplay = h > 0 ? h + (h == 1 ? " Hour, " : " Hours, ") : "";
  var mDisplay = m > 0 ? m + (m == 1 ? " Minute " : " Minutes ") : "";
  // var sDisplay = s > 0 ? s + (s == 1 ? " Second" : " Seconds") : "";
  return hDisplay + mDisplay;
};

const setDeep = (obj: any, path: any, value: any) => {
  const pList = path.split(".");
  const key = pList.pop();
  const pointer = pList.reduce((accumulator: any, currentValue: any) => {
    if (accumulator[currentValue] === undefined) accumulator[currentValue] = {};
    return accumulator[currentValue];
  }, obj);
  pointer[key] = value;
  return obj;
};

export const setIntraCity = (what: any, val: any) => {
  return async (dispatch: Dispatch) => {
    await dispatch({
      type: SET_INTRACITY,
      payload: {
        what,
        val,
      },
    });
  };
};

export const setIntraCityPickupDropLocation = (
  what: any,
  val: any,
  index: any
) => {
  return async (dispatch: Dispatch, getState: () => RootState) => {
    let { customerBooking } = getState();

    let intraCity =
      typeof customerBooking.intraCity === "object"
        ? customerBooking.intraCity
        : {};
    let pickDropLocation =
      typeof intraCity.pickDropLocation === "object"
        ? intraCity.pickDropLocation
        : [];
    console.log("in---", pickDropLocation);

    let newData = pickDropLocation.map((x: any, i: any) => {
      if (index === i) {
        console.log(setDeep(x, what, val));
        return setDeep(x, what, val);
      } else {
        return x;
      }
    });

    console.log("in---", newData);

    await dispatch({
      type: SET_INTRACITY_PICKUP_DROP_LOCATION,
      payload: newData,
    });
  };
};

export const addIntraCityPickupDropLocation = () => {
  return async (dispatch: Dispatch, getState: () => RootState) => {
    let { customerBooking } = getState();

    let intraCity =
      typeof customerBooking.intraCity === "object"
        ? customerBooking.intraCity
        : {};
    let pickDropLocation =
      typeof intraCity.pickDropLocation === "object"
        ? intraCity.pickDropLocation
        : [];

    pickDropLocation.push({
      id: pickDropLocation.length,
      place: {
        placeId: null,
        coordinate: {
          latitude: null,
          longitude: null,
        },
        placeValue: "",
        city: "",
        area: "",
        name: "",
        pincode: "",
        formatted_address: "",
      },
      contactPerson: {
        name: "",
        contact: "",
        floor: "",
        officeName: "",
        nearby_landmark: "",
        pincode: "",
        city: "",
        isDisabled: "",
      },
      isSubmited: false,
    });

    await dispatch({
      type: SET_INTRACITY_PICKUP_DROP_LOCATION,
      payload: pickDropLocation,
    });
  };
};

export const removeIntraCityPickupDropLocation = (index: number) => {
  return async (dispatch: Dispatch, getState: () => RootState) => {
    let { customerBooking } = getState();

    let intraCity =
      typeof customerBooking.intraCity === "object"
        ? customerBooking.intraCity
        : {};
    let pickDropLocation =
      typeof intraCity.pickDropLocation === "object"
        ? intraCity.pickDropLocation
        : [];
    let packages =
      typeof intraCity.packages === "object" ? intraCity.packages : [];

    pickDropLocation.splice(index, 1);

    let newPickDropLocation = pickDropLocation.map((x: any, i: any) => {
      return { ...x, id: i };
    });

    let newPackageData = packages
      .filter((x: any) => x.fromPlaceRef !== index)
      .map((x: any) => {
        let pkg = { ...x };

        if (x.toPlaceRef === index) {
          pkg.toPlaceRef = null;
        }
        return pkg;
      });
    await dispatch({
      type: SET_INTRACITY_PICKUP_DROP_LOCATION,
      payload: newPickDropLocation,
    });

    console.log("going data from here", newPackageData);
    await dispatch({
      type: SET_INTRACITY_PACKAGES,
      payload: newPackageData,
    });
  };
};

export const setIntraCityPackages = (what: any, val: any, index: any) => {
  return async (dispatch: Dispatch, getState: () => RootState) => {
    let { customerBooking } = getState();

    let intraCity =
      typeof customerBooking.intraCity === "object"
        ? customerBooking.intraCity
        : {};
    let packages =
      typeof intraCity.packages === "object" ? intraCity.packages : [];

    let newData = packages.map((x: any, i: any) => {
      if (index === i) {
        if (typeof what === "string") {
          return { ...x, [what]: val };
        } else {
          return setDeep(x, what, val);
        }
      } else {
        return x;
      }
    });

    await dispatch({
      type: SET_INTRACITY_PACKAGES,
      payload: newData,
    });
  };
};

export const addIntraCityPickupPackages = (setOnIndex: number) => {
  return async (dispatch: Dispatch, getState: () => RootState) => {
    let { customerBooking } = getState();

    let intraCity =
      typeof customerBooking.intraCity === "object"
        ? customerBooking.intraCity
        : {};
    let packages =
      typeof intraCity.packages === "object" ? intraCity.packages : [];

    packages.push({
      id: packages.length,
      materialType: null,
      qty: 0,
      codAmount: 0,
      orderNumber: "",
      // dimension: {
      //   l: 0,
      //   b: 0,
      //   h: 0,
      // },
      // weight: 0,
      // stack: false,
      // haz: false,
      // frag: false,
      fromPlaceRef: setOnIndex,
      toPlaceRef: null,
    });

    await dispatch({
      type: SET_INTRACITY_PACKAGES,
      payload: packages,
    });
  };
};

export const removeIntraCityPickupDropPackages = (index: number) => {
  return async (dispatch: Dispatch, getState: () => RootState) => {
    let { customerBooking } = getState();

    let intraCity =
      typeof customerBooking.intraCity === "object"
        ? customerBooking.intraCity
        : {};
    let packages =
      typeof intraCity.packages === "object" ? intraCity.packages : [];

    packages.splice(index, 1);

    let newData = packages.map((x: any, i: any) => {
      return { ...x, id: i };
    });
    await dispatch({
      type: SET_INTRACITY_PACKAGES,
      payload: newData,
    });
  };
};

export const createCustomerBookingRequest = () => {
  return async (dispatch: Dispatch, getState: () => RootState) => {
    try {
      let { customerBooking } = getState();
      let intraCity =
        typeof customerBooking.intraCity === "object"
          ? customerBooking.intraCity
          : {};

      let pickDropLocation =
        typeof intraCity.pickDropLocation === "object"
          ? intraCity.pickDropLocation
          : [];
      let packages =
        typeof intraCity.packages === "object" ? intraCity.packages : [];
      let vehicleType = intraCity.vehicleType.value;
      let city = pickDropLocation[0]?.place?.city;
      let gross = (intraCity.gross * +intraCity.totalDistanceMeter).toFixed(0);
      let paymentMode = intraCity.paymentMode;
      let paymentType = "cash";
      let intraCityRateType = intraCity.intraCityRateType;
      let points = intraCity.googleMapPolyLine?.points;

      dispatch({
        type: "START_LOADER",
      });

      let payload = processPayload(
        pickDropLocation,
        packages,
        city,
        gross,
        vehicleType
      );
      if (!payload) {
        return;
      }
      let response = await Axios({
        method: "post",
        url: url + "/customerBooking/createCustomerBookingRequestReq",
        data: {...payload,paymentMode,intraCityRateType,paymentType,points},
      });

      console.log("res", response);
      // showMessage("Booking Request Created", success);
      if(response?.status === 200){
        dispatch({
          type: CONFIRMED_BOOKING,
          payload: {
            what: "booked",
            val: true,
          },
        })
      }
      if(response?.status !== 200){
        // alert("I am Doing response Well !")
        dispatch({
          type: CONFIRMED_BOOKING,
          payload: {
            what: "booked",
            val: false,
          },
        })
      }
      // await dispatch({
      //   type: SET_INTRACITY_PICKUP_DROP_LOCATION,
      //   payload: [],
      // });

      // await dispatch({
      //   type: SET_INTRACITY_PACKAGES,
      //   payload: [],
      // });
    } catch (err) {
      console.log(err);
      showHttpError(err);
      dispatch({
        type: "END_LOADER",
      });
    }
  };
};

export const getIntraCityPrice = () => {
  return async (dispatch: Dispatch, getState: () => RootState) => {
    try {
      let { customerBooking } = getState();
      let intraCity =
        typeof customerBooking.intraCity === "object"
          ? customerBooking.intraCity
          : {};

      let pickDropLocation =
        typeof intraCity.pickDropLocation === "object"
          ? intraCity.pickDropLocation
          : [];
      let packages =
        typeof intraCity.packages === "object" ? intraCity.packages : [];
      // let vehicleType = intraCity.vehicleType;
      let city = intraCity.city;
      let gross = intraCity.gross;

      dispatch({
        type: "START_LOADER",
      });

      let payload = processPayload(
        pickDropLocation,
        packages,
        city,
        gross
      );
      if (!payload) {
        return;
      }
      let response = await Axios({
        method: "post",
        url: url + `/customerBooking/getAvailableServicesIntraCityPrice`,
        data: { ...payload, type: "EXPRESS" },
      });

      console.log("response", response);

      if (response?.data?.response?.length > 0) {
        await dispatch({
          type: SET_INTRACITY,
          payload: {
            what: "gross",
            val: response?.data?.response[0]?.price,
          },
        });
        await dispatch({
          type: SET_INTRACITY,
          payload: {
            what: "totalDistanceMeter",
            val: response?.data?.response[0]?.totalDistanceMeter / 1000,
          },
        });
        await dispatch({
          type: SET_INTRACITY,
          payload: {
            what: "totalDuration",
            val: secondsToHms(response?.data?.response[0]?.totalDuration),
          },
        });
        console.log("res", response);
        showMessage("Cost Fetched", success);
      } else {
        showMessage("No Intra City Rate Available", failed);
      }
    } catch (err) {
      console.log(err);
      showHttpError(err);
      dispatch({
        type: "END_LOADER",
      });
      await dispatch({
        type: SET_INTRACITY,
        payload: {
          what: "gross",
          val: 0,
        },
      });
    }
  };
};

export const actualgetIntraCityPrice = () => {
  return async (dispatch: Dispatch, getState: () => RootState) => {
    try {
      let { customerBooking } = getState();
      let intraCity =
        typeof customerBooking.intraCity === "object"
          ? customerBooking.intraCity
          : {};

      let pickDropLocation =
        typeof intraCity.pickDropLocation === "object"
          ? intraCity.pickDropLocation
          : [];
      let packages =
        typeof intraCity.packages === "object" ? intraCity.packages : [];
      // let vehicleType = intraCity.vehicleType.value;
      let city = pickDropLocation[0]?.place?.city;
      let gross = intraCity.gross;

      dispatch({
        type: "START_LOADER",
      });

      let payload = processPayload(
        pickDropLocation,
        packages,
        city,
        gross
      );
      if (!payload) {
        return;
      }
      let response = await Axios({
        method: "post",
        url: url + `/customerBooking/getIntraCityPrice`,
        data: { ...payload, type: "EXPRESS" },
      });

      console.log("response 1212", response?.data?.price?.price);

      if (response?.data?.price) {
        await dispatch({
          type: SET_INTRACITY,
          payload: {
            what: "vehicleList",
            val: response?.data?.price?.price,
          },
        });
        await dispatch({
          type: SET_INTRACITY,
          payload: {
            what: "totalDistanceMeter",
            val: (response?.data?.price?.distance / 1000).toFixed(2),
          },
        });
        await dispatch({
          type: SET_INTRACITY,
          payload: {
            what: "totalDuration",
            val: secondsToHms(response?.data?.price?.duration),
          },
        });
        await dispatch({
          type: SET_INTRACITY,
          payload: {
            what: "showFleets",
            val: true,
          },
        });
        await dispatch({
          type: SET_INTRACITY,
          payload: {
            what: "getPolyLine",
            val: true,
          },
        });
        console.log("res", response);
        showMessage("Cost Fetched", success);
      } else {
        showMessage("No Intra City Rate Available", failed);
      }
    } catch (err) {
      console.log(err);
      showHttpError(err);
      showMessage(`Intra City Rate Error :${err}`, failed);
      dispatch({
        type: "END_LOADER",
      });
      await dispatch({
        type: SET_INTRACITY,
        payload: {
          what: "gross",
          val: 0,
        },
      });
    }
  };
};

const processPayload = (
  pickupDropLocation: any,
  packages: any,
  city: any,
  gross: any,
  vehicleType? : any
) => {
  let errorMsg = "";
  try {
    let newData = packages.map((x: any) => {
      if (x.fromPlaceRef === null) {
        errorMsg = `${x.id}, Order Number: ${x.orderNumber} Has Not Pickup Location`;
      }

      if (x.toPlaceRef === null) {
        errorMsg = `Drop Location Required For Package No: ${x.id}, Order Number: ${x.orderNumber}`;
      }

      let from = pickupDropLocation[x.fromPlaceRef];
      let to = pickupDropLocation[x.toPlaceRef];

      return {
        id: x.id,
        materialType: x?.materialType?.value,
        qty: 1,
        codAmount: x.codAmount,
        customerPkgIdentifier: x.orderNumber,
        fromPlace: {
          placeId: from?.place?.placeId,
          coordinate: {
            latitude: from?.place?.coordinate.latitude,
            longitude: from?.place?.coordinate.longitude,
          },
          placeValue: from?.place?.placeValue,
          city: from?.place?.city,
          area: from?.place?.area,
          name: from?.place?.name,
          pincode: from?.place?.pincode,
          formatted_address: from?.place?.formatted_address,
          state: "Gujarat",
        },
        toPlace: {
          placeId: to?.place?.placeId,
          coordinate: {
            latitude: to?.place?.coordinate.latitude,
            longitude: to?.place?.coordinate.longitude,
          },
          placeValue: to?.place?.placeValue,
          city: to?.place?.city,
          area: to?.place?.area,
          name: to?.place?.name,
          pincode: to?.place?.pincode,
          formatted_address: to?.place?.formatted_address,
          state: "Gujarat",
        },
        sender: {
          name: from?.contactPerson?.name,
          contact: from?.contactPerson?.contact,
          // floor: from?.contactPerson?.floor,
          // officeName: from?.contactPerson?.officeName,
          // nearby_landmark: from?.contactPerson?.nearby_landmark,
          // pincode: from?.contactPerson?.pincode,
          // city: from?.contactPerson?.city
        },
        receiver: {
          name: to?.contactPerson?.name,
          contact: to?.contactPerson?.contact,
          // floor: to?.contactPerson?.floor,
          // officeName: to?.contactPerson?.officeName,
          // nearby_landmark: to?.contactPerson?.nearby_landmark,
          // pincode: to?.contactPerson?.pincode,
          // city: to?.contactPerson?.city
        },
        sAddress: {
          pincode: from?.contactPerson?.pincode,
          city: from?.contactPerson?.city,
          placeId: from?.place?.placeId,
          officeName: from?.contactPerson?.officeName,
          // floor: from?.contactPerson?.floor,
          nearby_landmark: from?.contactPerson?.nearby_landmark,
        },
        rAddress: {
          pincode: to?.contactPerson?.pincode,
          city: to?.contactPerson?.city,
          placeId: to?.place?.placeId,
          officeName: to?.contactPerson?.officeName,
          // floor: to?.contactPerson?.floor,
          nearby_landmark: to?.contactPerson?.nearby_landmark,
        },
      };
    });

    if (errorMsg) {
      showMessage(errorMsg, failed);
      return false;
    }

    return {
      type: "IntraCity",
      packages: newData,
      places: newData.map((x: any) => {
        return { fromPlace: x.fromPlace.placeId, toPlace: x.toPlace.placeId };
      }),
      city: city,
      gross: gross,
      vehicleType : vehicleType
    };
  } catch (err) {
    showHttpError(err);
  }
};

export const setCustomerBookingTracking = (data:any) => {
    
  return (dispatch:any)=>{
      dispatch({
          type:SET_BOOKING_TRACKING,
          payload:data
      })

  }
}

export const ResetCustomerBookingTracking = () => {
    
  return (dispatch:any)=>{
    dispatch({
      type:SET_BOOKING_RESET_TRACKING
    })
    
  }
}   

export const resetAllDataIntracityForm = () => {
  return (dispatch:any)=>{
    dispatch({
      type: RESET_INTERCITY,
      payload: [],
    });
    
    dispatch({
      type: SET_INTRACITY_PICKUP_DROP_LOCATION,
      payload: [],
    });

    dispatch({
      type: SET_INTRACITY_PACKAGES,
      payload: [],
    });

  }
}